import React, {useRef, useEffect} from "react"
import {Wrapper, Antd, Button } from "components"
import anime from 'animejs'
import Slider from "react-slick"
import {Layout, BlockDescription, Viewport, ModalVideos } from "../../components"
import MainExagon from './MainExagon'
import SmallExagon from './SmallExagon'
import theme from '../../style/theme'
import * as S from './styles'
import { getPath, isDesktop, getBlockDescriptionProps } from "../../utility"
import { useActiveValue } from "../../customHooks"

const Icon = Antd.Icon

const colors = ['rgb(25, 78, 126)', 'rgb(233, 121, 32)', 'rgb(248, 192, 48)','rgb(46, 151, 89)','rgb(25, 57, 158)', 'rgb(87, 39, 149)', 'rgb(183, 31, 25)' ]

export default (props) =>  {


  const myPageTitle = useRef()
  const myFirstSceneWrapper = useRef()

  const myLoading = useRef()
  const { translations, currentRoute, siteMetadata } = props.pageContext
  const { industries } = translations
  const industry = industries.find(industry => industry.slug === currentRoute.slug) 

  if(!industry) return null // redirect to 404
  const { title, description, items, image } = industry

  const {
    activeValue,
    setNext,
    setPre,
    setValue,
    onCancel,
  } = useActiveValue({maxValue: items.length})

  const { pathPrefix } = siteMetadata
  useEffect(() => {
    if(!myLoading || !myLoading || !myPageTitle || !myPageTitle.current || !myFirstSceneWrapper || !myFirstSceneWrapper.current) return

    var tl = anime.timeline({
      easing: 'linear',
    });
    tl
      .add({
        opacity: 0
      })
      .add({
        targets: myLoading.current,
        opacity: 0,
        duration: 600,
        easing: 'easeInOutQuad'
      })
      .add({
        targets: myPageTitle.current,
        opacity: 1,
        duration: 600,
        easing: 'easeInOutQuad'
      })
      .add({
        targets: myFirstSceneWrapper.current,
        opacity: 1,
        duration: 600,
        easing: 'easeInOutQuad'
      })

    
    return () => anime.remove(tl)
      
   }, [myLoading, myPageTitle, myFirstSceneWrapper])


  function handleScrollDown(id){
    if(typeof window === undefined) return
    anime({
      targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
      scrollTop: document.getElementById(`panel-${id}`).getBoundingClientRect().top,
      duration: 500,
      easing: 'easeInOutQuad'
    });

  }

  function handleScrollUp(id){
    if(typeof window === undefined) return
    anime({
      targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
      scrollTop: 0,
      duration: 500,
      easing: 'easeInOutQuad'
    });

  }


  const firstPanelImage = getPath(image, pathPrefix)
  return(
    <Layout {...props} inverted hasTitle={false}>

      <S.PageTitleWrapper>
        <Wrapper size="large">
          <S.PageTitle ref={myPageTitle}>{currentRoute.label}</S.PageTitle>
        </Wrapper>
      </S.PageTitleWrapper>
      <S.FirstPanel image={firstPanelImage}>
     
        <Wrapper size="large">
          <S.FirstSceneWrapper ref={myFirstSceneWrapper}>
            <S.ExagonIconWrapper>
              <MainExagon colors={colors} onClick={handleScrollDown} text={items.map(({exagonText}) => exagonText)} />
            </S.ExagonIconWrapper>
            <S.Content>
              <S.Title>{title}</S.Title>
              <S.Description>{description}</S.Description>
            </S.Content>
          </S.FirstSceneWrapper>
         
        </Wrapper>
        <S.Loading ref={myLoading}><Icon type="loading" /></S.Loading>
      </S.FirstPanel>
 
      {items.map(({slides, exagonText, video}, index) => (
        <Viewport key={exagonText}>
            {({isVisible}) => (
            <S.Panel color={index % 2 ? 'white' : theme.colors.lightGray.secondary} id={`panel-${index}`}>
              <Wrapper size="large">
                <S.PanelHeader >
                  <S.SmallExagonIconWrapper>
                    <SmallExagon color={colors[index]} />
                  </S.SmallExagonIconWrapper>
                  {exagonText.join(" ")}
                </S.PanelHeader>
                  {video && <S.IconPlayWrapper className="panel-header-icons">
                    <Button onClick={() => setValue(index)} type={null} icon="play-circle" >Play video </Button>
                  </S.IconPlayWrapper>}
                  {slides?.length > 0 && <Slider {...{
                    dots: true,
                    arrows: true,
                    autoplaySpeed: isDesktop?4000:6000,
                    autoplay: true,
                    nextArrow: <Icon type="right" />,
                    prevArrow: <Icon type="left" />,
                  }}>
                  {
                    slides.map(slide => {

                      const item = {
                        ...slide,
                        images: [slide.image]
                      }
                      const props = getBlockDescriptionProps({item, index, pathPrefix})
                      return <S.Slide><BlockDescription {...props} /></S.Slide>
                    })
                  }
                </Slider>}
                <S.ScrollUpIconWrapper onClick={handleScrollUp}><Icon type="up-circle"  /></S.ScrollUpIconWrapper>
                
              </Wrapper>
            </S.Panel>
            )}
          </Viewport>
  
      ))}

      <ModalVideos
        videos={items.map((el, index) => ({
          title: el.exagonText.join(" "),
          src: el.video,
          color: colors[index]
        }))}
        activeValue={activeValue}
        onCancel={onCancel}
        setNext={setNext}
        setPre={setPre}
      />
      
    </Layout>
  )
}